/* eslint-disable no-restricted-globals */
import { dwmRepository, MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$stateParams', '$http', '$rootScope', 'Util'];

class DwmNotifications {

    constructor($scope, $stateParams, $http, $rootScope, Util) {

        const notificationId = $stateParams.resourceId;
        $scope.user = MeRepository.getMyUser();
        $scope.showOtpScreen = false;
        $scope.addOtpScreen = false;
        $scope.otpCode = { value: '' };

        const onDwmDataNext = () => {

            const alertsDetails = dwmRepository.getAll('alertsDetails');
            const statusApi = dwmRepository.getAll('statusApi');

            if (Object.keys(statusApi).length) {

                const aiaSubscriptioneStatus = Util.deepFind(statusApi, 'products.identityAssist.subscriptionStatus');
                const dwmLiteSubscriptionStatus = Util.deepFind(statusApi, 'products.dwmLite.subscriptionStatus');

                const aiaSubscriptionCancelled = aiaSubscriptioneStatus === 'cancelled' || aiaSubscriptioneStatus === 'none' || aiaSubscriptioneStatus === 'unknown';
                const dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none' || dwmLiteSubscriptionStatus === 'unknown';
                const aiaSubscriptionActive = aiaSubscriptioneStatus === 'active';
                const dwmLiteSubscriptionActive = dwmLiteSubscriptionStatus === 'active';

                if (aiaSubscriptionCancelled &&
                    !aiaSubscriptionActive &&
                    !dwmLiteSubscriptionActive) {

                    Util.closeModal();

                } else if (dwmLiteSubscriptionCancelled &&
                    !aiaSubscriptionActive &&
                    !dwmLiteSubscriptionActive) {

                    Util.closeModal();

                }

            }

            if (!alertsDetails[notificationId]) {

                $scope.notificationStatus = 'loading';

            } else {

                $scope.notificationStatus = 'loaded';

                const alertDetail = alertsDetails[notificationId];
                const configNextSteps = CWCONFIG.dwm.nextStepsLinks;

                const currentLanguage = CWCONFIG.language;

                let redirectLanguage = '';
                if (currentLanguage === 'en') {

                    redirectLanguage = 'en-us';

                } else {

                    redirectLanguage = currentLanguage;

                }

                alertDetail.detailViews.forEach((alert) => {

                    const section6 = alert.sections.find(section => section.sectionId === 'next_steps');
                    const section6Index = alert.sections.findIndex(section => section.sectionId === 'next_steps');

                    if (section6) {

                        if (section6.params) {

                            section6.params.forEach((param) => {

                                const aviraLink =
                                    configNextSteps.find(link => link.action === param.action);
                                let link;

                                if (aviraLink) {

                                    link = `<a href='${aviraLink.articleUrl.replace(/\[language\]/gi, redirectLanguage)}' ${aviraLink.target ? 'target=_blank' : ''} class='text-blue-1'>${param.displayText.replace('Norton', 'Avira')}</a>`;

                                }

                                const stringToReplace = `\${${param.paramName}}`;

                                let paramToReplace;

                                if (section6.data) {

                                    paramToReplace = section6.data
                                        .find(data => data.indexOf(stringToReplace) > -1);

                                } else if (section6.text) {

                                    paramToReplace = section6.text
                                        .find(data => data.indexOf(stringToReplace) > -1);

                                }

                                if (paramToReplace) {

                                    paramToReplace =
                                        paramToReplace.replace(stringToReplace, link);

                                }

                                if (section6.data) {

                                    section6.data.forEach((data, index2) => {

                                        alert.sections[section6Index].data[index2] =
                                            data.replace(stringToReplace, link);

                                    });

                                }

                                if (section6.text) {

                                    section6.text.forEach((data, index2) => {

                                        alert.sections[section6Index].text[index2] =
                                            data.replace(stringToReplace, link);

                                    });

                                }

                            });

                        }

                    }

                });

            }

            if ($rootScope.dwmNortonToken && !alertsDetails[notificationId]) {

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/alerts/${notificationId}`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                        lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US',
                    },

                }).then((response) => {

                    dwmRepository.updateAlertsDetails(notificationId, response.data.alertDetail);
                    $scope.notificationStatus = 'loaded';

                }).catch(() => {

                    $scope.notificationStatuses = 'error';
                    Alert.error('cw.modal.server-error.desc');

                });

            } else if (Object.keys(alertsDetails).length > 0 && notificationId) {

                $scope.notifications = alertsDetails[notificationId];
                $scope.hasPagination = $scope.notifications.detailViews.length > 1;
                $scope.notificationIndex = 0;
                $scope.nextArrowEnabled = true;
                $scope.prevArrowEnabled = false;
                $scope.activePage = 1;
                $scope.notification =
                    alertsDetails[notificationId].detailViews[$scope.notificationIndex];

            }

        };

        $scope.nextPage = () => {

            $scope.activePage += 1;
            $scope.notificationIndex += 1;
            $scope.nextArrowEnabled =
                !!($scope.activePage < $scope.notifications.detailViews.length);
            $scope.prevArrowEnabled = !!($scope.activePage !== 1);
            $scope.notification = $scope.notifications.detailViews[$scope.notificationIndex];

        };

        $scope.prevPage = () => {

            $scope.activePage -= 1;
            $scope.notificationIndex -= 1;
            $scope.nextArrowEnabled =
                !!($scope.activePage < $scope.notifications.detailViews.length);
            $scope.prevArrowEnabled = !!($scope.activePage !== 1);
            $scope.notification = $scope.notifications.detailViews[$scope.notificationIndex];

        };

        $scope.showPassword = (email) => {

            Mixpanel.send('ConnectWeb AIA Notification Show Password Click');
            $scope.showOtpScreen = true;
            $scope.currentNotificationEmailAddress = email;

        };

        $scope.showAddOtpScreen = () => {

            $scope.addOtpScreen = true;

        };

        $scope.sendOtpOnEmail = () => {

            $scope.loading = true;

            $http({
                method: 'POST',
                url: `${CWCONFIG.dwm.restApi}/v1/auth/email`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data: {
                    emailAddress: $scope.currentNotificationEmailAddress,
                    alertId: notificationId,
                },

            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Notification Send OTP Success');
                $scope.loading = false;
                $scope.addOtpScreen = true;

            }).catch(() => {

                $scope.loading = false;
                Alert.error('cw.modal.server-error.desc');

            });

        };

        $scope.requestNewCode = () => {

            $scope.otpCode = { value: '' };
            $scope.otpError = false;
            $scope.addOtpScreen = false;

        };

        $scope.updateOtpError = () => {

            $scope.otpError = false;

        };

        $scope.verifyOtpOnEmail = () => {

            $scope.loading = true;
            $scope.otpError = false;

            if ($scope.otpCode.value && $scope.otpCode.value.length === 6) {

                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/auth/email/verify`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: {
                        emailAddress: $scope.currentNotificationEmailAddress,
                        otp: $scope.otpCode.value,
                    },
                }).then(() => {

                    Mixpanel.send('ConnectWeb AIA Notification Verify OTP Success');
                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/alerts/${notificationId}`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                            lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US',
                        },

                    }).then((response) => {

                        dwmRepository
                            .updateAlertsDetails(notificationId, response.data.alertDetail);

                        $scope.loading = false;
                        $scope.showOtpSuccess = true;

                    }).catch(() => {

                        $scope.loading = false;
                        $scope.notificationStatuses = 'error';
                        Alert.error('cw.modal.server-error.desc');

                    });

                }).catch((responseError) => {

                    $scope.loading = false;
                    $scope.otpError = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 150002) {

                            Alert.error('cw.auth.tfa.error.expired_otp');

                        } else {

                            Alert.error('w.modal.server-error.desc');

                        }

                    }

                });

            } else {

                $scope.loading = false;
                $scope.otpError = true;

            }

        };

        $scope.backToNotification = () => {

            $scope.showOtpScreen = false;

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        const dwmSubscriber = dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.$on('$destroy', () => {

            if ($rootScope.dwmNortonToken) {

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/alerts`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                        lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US',
                    },

                }).then((alertsResponse) => {

                    dwmRepository.replace('alerts', alertsResponse.data);

                    let aiaUnreadAlerts = 0;
                    let aiaReadAlerts = 0;

                    if (alertsResponse.data.alertList.length > 0) {

                        alertsResponse.data.alertList.forEach((alert) => {

                            if (alert.isRead === false && alert.bucket === 'inbox') {

                                aiaUnreadAlerts += 1;

                            }

                        });

                        aiaReadAlerts = alertsResponse.data.alertList.length - aiaUnreadAlerts;

                    }

                    if (aiaUnreadAlerts > 0) {

                        $rootScope.dwmCardUnreadNotifications = aiaUnreadAlerts;

                    } else if (aiaUnreadAlerts === 0 && $rootScope.dwmCardUnreadNotifications > 0) {

                        $rootScope.showDwmCardHomepage = false;
                        $rootScope.showDwmUnreadNotificationsCard = false;

                    }

                    Mixpanel.setCommonProperty('AIA Unread Alerts', aiaUnreadAlerts);
                    Mixpanel.setCommonProperty('AIA Read Alerts', aiaReadAlerts);

                    dwmSubscriber.dispose();

                }).catch(() => {

                    Alert.error('cw.modal.server-error.desc');
                    dwmSubscriber.dispose();

                });

            }

        });

        Mixpanel.send('ConnectWeb AIA Notification Open');

    }

}

_serviceDependencies.push(DwmNotifications);

angular.module('controllers')
    .controller('DwmNotifications', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/notifications/notifications.js